module.exports = __webpack_public_path__ + "img/SY.16f6ad98.png";